var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.019 10.723-2.117-.242a1.659 1.659 0 0 0-1.367.475L9.002 12.49A12.538 12.538 0 0 1 3.51 6.998l1.542-1.542c.358-.358.533-.858.475-1.366l-.242-2.1A1.668 1.668 0 0 0 3.627.515H2.185C1.244.515.46 1.298.52 2.24.96 9.356 6.652 15.04 13.76 15.48c.942.059 1.725-.725 1.725-1.666v-1.442a1.652 1.652 0 0 0-1.466-1.65Z",
    fill: "#2BB9A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.7dedc227e312f7e8b63a9fa729d2a4d9.svg";
export { ForwardRef as ReactComponent };